export const modalMinHeight = 400;
